import script from "./Jodit.vue?vue&type=script&setup=true&lang=js"
export * from "./Jodit.vue?vue&type=script&setup=true&lang=js"

import "./Jodit.vue?vue&type=style&index=0&id=4adc43bc&lang=scss"

const __exports__ = script;

export default __exports__